import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { Const, ResourceType } from '../../../../core/helpers/Const';
import { NotificationsService } from '../../../../service/services/misc/notifications/notifications.service';
import {firstValueFrom, Observable} from 'rxjs';
import {FetchResponse, IsCompleted, PollingService, Pool} from "../../../../service/services/misc/polling";
import {ResourceDataService} from "../../../../service/services/rest/resource-data/resource-data.service";

@Component({
    selector: 'app-delete-confirmation-dialog',
    templateUrl: './delete-folder-with-data-dialog.component.html',
    styleUrls: ['./delete-folder-with-data-dialog.component.scss'],
    standalone: false
})
export class DeleteFolderWithDataDialogComponent implements OnInit {
    resource: ResourceModel;
    managedServiceArray: ResourceModel[];
    type: string;
    msg: string;
    title: string;
    errorMsg: string;
    Const = Const;
    deleteFunc: () => Observable<any>;
    loading = false;
    isSaveEnabled = false;
    pool : Pool;


    constructor(
		public dialogRef: DialogRef,
		private notificationsService: NotificationsService,
        private resourceDataService: ResourceDataService,
        private pollingService: PollingService
    ) {}

    FAILED_MSGS: { [key: string]: string } = {
        [ResourceType.FOLDER]: 'Cannot delete folder',
    };
    ngOnInit(): void {
        let data = this.dialogRef.data;
        this.type = 'warning';
        this.title = "Delete Folder with Content";
        this.resource = data.resource;
        this.managedServiceArray = data.managedServiceArray;
        this.deleteFunc = data.deleteFunc;
        this.pool = this.pollingService.buildPool({tolerateError: false });
    }

    addUrlTask(url: string, isCompleted?: IsCompleted): Promise<any> | Observable<any> {
        let PollFunction = async () => {
            let r = await fetch(url);
            let fetchResponse: FetchResponse = {
                status: r.status,
                url: r.url,
                headers: r.headers,
                ok: r.ok,
                statusText: r.statusText,
                body: await r.text(),
            };
            try {
                fetchResponse.body = JSON.parse(fetchResponse.body);
            } catch (e) {}
            return fetchResponse;
        };
        return this.pollingService.addUniquePoolTask(PollFunction, this.pool ,isCompleted);
    }

    async onDelete() {
        this.loading = true;
        this.dialogRef.loading(true);
        try {
            await this.deleteManagedServices(this.managedServiceArray);
        } catch (e) {
            this.dialogRef.dismiss(e);
        } finally {
            this.loading = false;
            this.dialogRef.loading(false);
        }
        this.dialogRef.close(this.resource);
        this.onSuccess();
    }

    async deleteManagedServices(managedServiceArray: ResourceModel[]) {
        for (const res of managedServiceArray) {
            let url = `/${res.apiVersion}/${res.type}${res.path}`;
            const queryString = this.getDeletionQueryString(res);

            await firstValueFrom(this.resourceDataService.delete(url, res.name, queryString));
            url = "/api/resources" + url + "/" + res.name;
            await this.addUrlTask(url, (response: FetchResponse) => {
                // Successful Deletion returns 404
                if (!response.ok) {
                    if (response?.status !== 404) {
                        throw response.body;
                    } else {
                        return true;
                    }
                }
                return false;
            });
        }
    }

    getDeletionQueryString(resourceToDelete: ResourceModel) {
        const mixedIntoApiVersion = resourceToDelete.resource?.metadata?.mixedInto?.apiVersion;
        const mixedIntoType = resourceToDelete.resource?.metadata?.mixedInto?.type;
        let query = "";
        if (mixedIntoApiVersion && mixedIntoType) {
            query = `?mixedIntoApiVersion=${mixedIntoApiVersion}&mixedIntoType=${mixedIntoType}`;
        }
        return query;
    }

    onSuccess() {
        this.notificationsService.showMessageToast(
            'Deleting resource ' + this.resource.name + ' (' + this.resource.type + ')...'
        );
    }

    validate() {
        return !this.loading && this.isSaveEnabled;
    }
}
